export default "__VITE_ASSET__DSZv4rrc__"